import { getValue } from "@utils/lodash";
import "./filter-form.scss";
// import AddFilterNew from "../AddFilterNew";
import InputField from "@_common/InputRuleFeild";
import SearchableDropdownSelect from "@_common/SearchableDropdown";
import ResetSvgComponent from "../../../../assets/svg-components/reset";

export default function FilterForm(props: any) {
  const {
    handleChangeSelect,
    countryList,
    states,
    categoryOfLawList,
    legislationList,
    ruleList,
    request,
    additionalFilter,
    smartFilterList,
    selectedSmartFilterIds,
    handleChangeSelectMulti,

    //loading...
    categoryLawLoading,
    legislationLoading,
    legislationRuleLoading,
    locationLoading,
    functionLoading,
    resetInput,
    citiesList,
    groupList,
    regionList,
    // showFilterPopup,
    // setShowFilterPopup,
  } = props;
  return (
    <div
      className={`filter-slidder-wrapper  ${
        props.filterIsOpen ? "filter-slidder-wrapper--active" : ""
      }`}
    >
      <div className="filter-form-wrappper w-100 active border_bottom">
        <div className="filter-form-wrappper__container">
          <div className="filter-header-wrapper d-flex align-items-center justify-content-between">
            <div className="filter-header-left-wrapper d-flex align-items-center">
              <div className="filter-close-wrapper">
                <img
                  src="/images/close-circle.svg"
                  className="img-fluid cursor-pointer"
                  onClick={props.handleFilter}
                />
              </div>
              <div className="filter-title-wrapper">
                <h6 className="filter-form-wrappper__title">Filter</h6>
              </div>

              <div className="filter-module-details-wrapper">
                <div className="filter-module-name">{props.moduleName}</div>
                <div className="filter-submodule-name">
                  {props.subModuleName}
                </div>
              </div>
            </div>

            <div className="filter-header-right-wrapper">
              <div className="filter-form-wrappper__cta-wrapper p-0 d-flex">
                <button
                  className="filter-form-wrappper__cta-btn filter-form-wrappper__cta-btn--reset"
                  onClick={props.reset}
                >
                  <div className="d-flex align-items-center mt--3">
                    <ResetSvgComponent size={24} color={"#5F6368"} /> Reset
                  </div>
                </button>

                <button
                  className="filter-form-wrappper__cta-btn filter-form-wrappper__cta-btn--cancel"
                  onClick={props.handleFilter}
                >
                  Cancel
                </button>
                {getValue(props, `country_ID.length`, 0) > 0 ? (
                  <button
                    className="filter-form-wrappper__cta-btn filter-form-wrappper__cta-btn--search"
                    onClick={props.handleSubmitSmartFilter}
                  >
                    Search
                  </button>
                ) : (
                  <button
                    className="filter-form-wrappper__cta-btn filter-form-wrappper__cta-btn--disable"
                    onClick={props.handleSubmitSmartFilter}
                  >
                    Search
                  </button>
                )}
              </div>
            </div>
          </div>

          <div className="filter-body-wrapper">
            <div className="filter-body-card">
              <div className="filter-card-title">Filter By</div>
              <div className="d-flex justify-content-between flex-column">
                <div className="filter-form-wrappper__location">
                  <div className="d-flex w-100 filter-field-main-wrap">
                    <div className="filter-form-wrappper__location-form-group form-group filter-field-children-wrap">
                      <label
                        htmlFor="country"
                        className="filter-form-wrappper__label filter-fields-label"
                      >
                        Country
                      </label>
                      <div className="filter-form-wrappper__location-input select-dd-new">
                        <InputField
                          inputType="INPUT_REACT_SELECT"
                          placeholder="Choose Country"
                          className="form-control w-100"
                          name="country_id"
                          id="country_id"
                          options={countryList}
                          value={props.country_ID}
                          onChange={(e: any) =>
                            handleChangeSelect(e, "country_id")
                          }
                          label="Country"
                        />
                      </div>
                    </div>
                    <div className="filter-form-wrappper__location-form-group form-group filter-field-children-wrap">
                      <label
                        htmlFor="state"
                        className="filter-form-wrappper__label filter-fields-label"
                      >
                        State
                      </label>
                      <div className="filter-form-wrappper__location-input select-dd-new">
                        <InputField
                          inputType="INPUT_REACT_SELECT"
                          placeholder="Choose State"
                          className="form-control w-100"
                          name="state_id"
                          id="state_id"
                          label="Last Name"
                          options={states}
                          value={props.state_ID}
                          onChange={(e: any) =>
                            handleChangeSelect(e, "state_id")
                          }
                          isClear
                        />
                      </div>
                    </div>
                  </div>

                  <div className="d-flex w-100 filter-field-main-wrap">
                    {getValue(props, `location`, false) && (
                      <div className="filter-form-wrappper__location-form-group form-group filter-field-children-wrap">
                        <label
                          htmlFor="state"
                          className="filter-form-wrappper__label filter-fields-label"
                        >
                          City
                        </label>
                        <div className="filter-form-wrappper__location-input select-dd-new">
                          <InputField
                            inputType="INPUT_REACT_SELECT"
                            placeholder="Choose City"
                            className="form-control w-100"
                            name="city_id"
                            id="city_id"
                            label="Last Name"
                            options={citiesList}
                            value={props.city_ID}
                            onChange={(e: any) =>
                              handleChangeSelect(e, "city_id")
                            }
                            isClear
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                {getValue(props, `location`, false) &&
                  !getValue(props, `vendor`, false) && (
                    <div className="filter-form-wrappper__location">
                      <div className="d-flex w-100 filter-field-main-wrap">
                        <div className="filter-form-wrappper__location-form-group form-group filter-field-children-wrap">
                          <label
                            htmlFor="state"
                            className="filter-form-wrappper__label filter-fields-label"
                          >
                            Region
                          </label>
                          <div className="filter-form-wrappper__location-input select-dd-new">
                            <InputField
                              inputType="INPUT_REACT_SELECT"
                              placeholder="Choose Region"
                              className="form-control w-100"
                              name="region_id"
                              id="region_id"
                              label="Last Name"
                              options={regionList}
                              value={props.region_ID}
                              onChange={(e: any) =>
                                handleChangeSelect(e, "region_id")
                              }
                              isClear
                            />
                          </div>
                        </div>

                        <div className="filter-form-wrappper__location-form-group form-group filter-field-children-wrap">
                          <label
                            htmlFor="state"
                            className="filter-form-wrappper__label filter-fields-label"
                          >
                            Group
                          </label>
                          <div className="filter-form-wrappper__location-input select-dd-new">
                            <InputField
                              inputType="INPUT_REACT_SELECT"
                              placeholder="Choose Group"
                              className="form-control w-100"
                              name="group_id"
                              id="group_id"
                              label="Last Name"
                              options={groupList}
                              value={props.group_ID}
                              onChange={(e: any) =>
                                handleChangeSelect(e, "group_id")
                              }
                              isClear
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                {!getValue(props, `location`, false) && (
                  <>
                    {!getValue(props, `internal`, false) && (
                      <div className="filter-form-wrappper__location ">
                        <div className="d-flex w-100 filter-field-main-wrap">
                          <div className="filter-form-wrappper__location-form-group form-group filter-field-children-wrap">
                            <label
                              htmlFor="law"
                              className="filter-form-wrappper__label filter-fields-label"
                            >
                              Category of Law
                            </label>
                            <div className="filter-form-wrappper__location-input select-dd-new">
                              <SearchableDropdownSelect
                                placeholder={"Choose Category of Law"}
                                options={categoryOfLawList}
                                searchLoading={categoryLawLoading}
                                handleChange={(val: any) =>
                                  props.getCategoryLawList(val)
                                }
                                handleClick={(e: any) =>
                                  props.handleChangeSelect(
                                    e,
                                    "category_of_law_id"
                                  )
                                }
                                value={getValue(props, `cat_ID[${0}]`, {})}
                                label="label"
                                id="id"
                                name="Category of Law"
                                resetInput={resetInput}
                              />
                            </div>
                          </div>
                          <div className="filter-form-wrappper__location-form-group form-group filter-field-children-wrap">
                            <label
                              htmlFor="legislation"
                              className="filter-form-wrappper__label filter-fields-label"
                            >
                              Legislation
                            </label>
                            <div className="filter-form-wrappper__location-input select-dd-new">
                              <SearchableDropdownSelect
                                placeholder={"Choose Legislation"}
                                options={legislationList}
                                searchLoading={legislationLoading}
                                handleChange={(val: any) =>
                                  props.getLegislationList(val)
                                }
                                handleClick={(e: any) =>
                                  props.handleChangeSelect(e, "legislation_id")
                                }
                                value={getValue(props, `leg_ID[${0}]`, {})}
                                label="label"
                                id="id"
                                name="Legislation"
                                resetInput={resetInput}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="d-flex w-100 filter-field-main-wrap">
                          <div className="filter-form-wrappper__location-form-group form-group filter-field-children-wrap">
                            <label
                              htmlFor="rule"
                              className="filter-form-wrappper__label filter-fields-label"
                            >
                              Rule
                            </label>
                            <div className="filter-form-wrappper__location-input select-dd-new">
                              <SearchableDropdownSelect
                                placeholder={"Choose Legislation Rule"}
                                options={ruleList}
                                searchLoading={legislationRuleLoading}
                                handleChange={(val: any) =>
                                  props.getLegislationRuleList(val)
                                }
                                handleClick={(e: any) =>
                                  props.handleChangeSelect(
                                    e,
                                    "legislation_rule_id"
                                  )
                                }
                                value={getValue(props, `rule_ID[${0}]`, {})}
                                label="label"
                                id="id"
                                name="Legislation Rule"
                                resetInput={resetInput}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {props.events && (
                      <div className="filter-form-wrappper__location">
                        <div className="d-flex w-100 filter-field-main-wrap">
                          <div className="filter-form-wrappper__location-form-group form-group filter-field-children-wrap">
                            <label
                              htmlFor="law"
                              className="filter-form-wrappper__label filter-fields-label"
                            >
                              Events
                            </label>
                            <div className="filter-form-wrappper__location-input select-dd-new">
                              <SearchableDropdownSelect
                                placeholder={"Choose Event"}
                                options={props.eventList}
                                searchLoading={props.eventLoading}
                                handleChange={(val: any) =>
                                  props.getEventsList(val)
                                }
                                handleClick={(e: any) =>
                                  props.handleChangeSelect(e, "event_id")
                                }
                                value={getValue(props, `event_ID[${0}]`, {})}
                                label="label"
                                id="id"
                                name="Event"
                                resetInput={resetInput}
                              />
                            </div>
                          </div>

                          <div className="filter-form-wrappper__location-form-group form-group filter-field-children-wrap">
                            <label
                              htmlFor="legislation"
                              className="filter-form-wrappper__label filter-fields-label"
                            >
                              SubEvents
                            </label>
                            <div className="filter-form-wrappper__location-input select-dd-new">
                              <SearchableDropdownSelect
                                placeholder={"Choose Sub Event"}
                                options={props.subEventList}
                                searchLoading={props.subEventLoading}
                                handleChange={(val: any) =>
                                  props.getSubEventsList(val)
                                }
                                handleClick={(e: any) =>
                                  props.handleChangeSelect(e, "sub_event_id")
                                }
                                value={getValue(props, `subevent_ID[${0}]`, {})}
                                label="label"
                                id="id"
                                name="Event"
                                resetInput={resetInput}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                )}

                {additionalFilter && (
                  <div className="filter-form-wrappper__container border-0">
                    <div className="d-flex justify-content-between gap">
                      {/* <div className="filter-form-wrappper__location flex-1 mb-0"> */}
                      <div className="d-flex w-100 filter-field-main-wrap">
                        <div className="filter-form-wrappper__location-form-group form-group filter-field-children-wrap">
                          <label
                            htmlFor="rule"
                            className="filter-form-wrappper__label filter-fields-label"
                          >
                            Additional Filter
                          </label>
                          <div className="filter-form-wrappper__location-input select-dd-new">
                            <InputField
                              inputType="INPUT_REACT_SELECT"
                              placeholder="Choose Additional Filter"
                              className="form-control"
                              name="legislation_rule_id"
                              id="legislation_rule_id"
                              label="Legislation Rule ID"
                              options={smartFilterList}
                              value={selectedSmartFilterIds}
                              onChange={(e: any) => handleChangeSelectMulti(e)}
                              isMulti
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* <div className="filter-form-wrappper__location my-2">
              <div className="filter-form-wrappper__location-form-group form-group">
                <label htmlFor="country" className="filter-form-wrappper__label filter-fields-label">
                  Tags
                </label>
                <div className="filter-form-wrappper__location-input select-dd-new">
                  <input
                    type="text"
                    placeholder="Choose Tags"
                    id="country"
                    className="filter-form-wrappper__form-control form-control"
                  />
                  <img
                    src="/images/arrow-drop.svg"
                    className="img-fluid filter-form-wrappper__image"
                  />
                </div>
              </div>
            </div> */}
                  </div>
                )}

                {getValue(props, `hideActive`, false) && (
                  <div>
                    <label
                      htmlFor="rule"
                      className="filter-form-wrappper__label filter-fields-label"
                    >
                      Show Inactive
                    </label>
                    <br />
                    <div className="choicelist-wrapper custom-switch-wrapper">
                      <label className="switch">
                        <input
                          type="checkbox"
                          checked={
                            getValue(props, `request.status`, "") === "inactive"
                              ? true
                              : false
                          }
                          onChange={() =>
                            props.handleChangeSelectByDirectValue(
                              getValue(props, `request.status`, "") ===
                                "inactive"
                                ? "active"
                                : "inactive",
                              "status"
                            )
                          }
                        />
                        <span className="slider round"></span>
                      </label>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* <div className="filter-form-wrappper__cta-wrapper">
          {getValue(props, `country_ID.length`, 0) > 0 ? (
            <button
              className="filter-form-wrappper__cta-btn filter-form-wrappper__cta-btn--search"
              onClick={props.handleSubmitSmartFilter}
            >
              Search
            </button>
          ) : (
            <button
              className="filter-form-wrappper__cta-btn filter-form-wrappper__cta-btn--disable"
              onClick={props.handleSubmitSmartFilter}
            >
              Search
            </button>
          )}
          <button
            className="filter-form-wrappper__cta-btn filter-form-wrappper__cta-btn--reset"
            onClick={props.reset}
          >
            Reset
          </button>
        </div> */}

        {/* <AddFilterNew /> */}
      </div>
    </div>
  );
}
